import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Grid } from "@mui/material";
import { useActiveFacultiesFieldsQuery } from "api/faculty/faculty.mutation";
import {
  useCreateFacultyGroupMutation,
  useUpdateFacultyGroupMutation,
} from "api/facultyGroups/facultyGroups.mutation";
import { Modal } from "components/Modal";
import SelectField from "components/Select";
import TextField from "components/TextField";
import { handleError } from "functions/apiHandleError";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { schema } from "schema/facultyGroup/createUpdateModal";
import classes from "./style.module.scss";

export const CreateUpdateFacultyGroupModal = ({ open, onClose, defaultData }) => {
  const { handleSubmit, reset, setError, control, watch, resetField } = useForm({
    mode: "onChange",
    resolver: zodResolver(schema),
    defaultValues: {
      name: "",
      faculty: "",
      fields: [],
    },
  });

  const [loading, setLoading] = useState(false);
  const [facultyFieldsData, setFacultyFieldsData] = useState([]);
  const activeFacultiesFieldsQuery = useActiveFacultiesFieldsQuery();
  const createFacultyGroupMutation = useCreateFacultyGroupMutation();
  const updateFacultyGroupMutation = useUpdateFacultyGroupMutation();
  const facultiesData = useMemo(
    () =>
      (activeFacultiesFieldsQuery.data ?? []).map((item) => ({
        value: String(item?.id),
        label: item?.fa_name,
        fields: item?.fields_of_studies,
      })),
    [activeFacultiesFieldsQuery.data]
  );

  const handleCloseModal = () => {
    reset({
      name: "",
      faculty: "",
      fields: [],
    });
    onClose();
  };
  const handleSubmitForm = async (data) => {
    setLoading(true);
    try {
      if (defaultData) {
        await updateFacultyGroupMutation.mutateAsync({ pk: defaultData?.id, data });
      } else {
        await createFacultyGroupMutation.mutateAsync(data);
      }
      toast.success("با موفقیت انجام شد");
      handleCloseModal();
    } catch (err) {
      handleError({ err, setError });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const selectedFaculty = facultiesData.find((item) => item.value === watch("faculty"));
    if (selectedFaculty) {
      const FacultyFieldsListVariable = [];
      selectedFaculty?.fields?.map((item) => {
        FacultyFieldsListVariable.push({
          value: String(item?.id),
          label: item?.fa_name,
        });
      });
      setFacultyFieldsData(FacultyFieldsListVariable);
      resetField("fields");
    }
  }, [watch("faculty")]);
  useEffect(() => {
    if (defaultData) {
      reset({
        name: defaultData?.name,
        faculty: String(defaultData?.faculty),
        fields: defaultData?.fields?.map((item) => String(item)),
      });
    }
  }, [defaultData]);

  return (
    <Modal
      open={open}
      title={defaultData ? "ویرایش گروه" : "ایجاد گروه"}
      onClose={handleCloseModal}
      maxWidth="sm"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={
              loading ||
              createFacultyGroupMutation.isPending ||
              updateFacultyGroupMutation.isPending
            }
            color={defaultData ? "primary" : "success"}
            onClick={handleSubmit(handleSubmitForm)}
          >
            ثبت
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={handleCloseModal}>
            بستن
          </Button>
        </>
      }
    >
      <Grid
        container
        spacing={3}
        component="form"
        onSubmit={handleSubmit(handleSubmitForm)}
        className={classes.wrapper}
      >
        <Grid item xs={12}>
          <TextField label="نام گروه" required control={control} name="name" />
        </Grid>
        <Grid item xs={12}>
          <SelectField
            label="دانشکده"
            options={facultiesData}
            required
            control={control}
            name="faculty"
          />
        </Grid>
        <Grid item xs={12}>
          <SelectField
            label="گرایش ها"
            disabled={!watch("faculty")}
            options={facultyFieldsData}
            required
            checkMarks
            control={control}
            name="fields"
          />
        </Grid>
      </Grid>
    </Modal>
  );
};
